import { defineStore } from 'pinia'

export type Consent = 'granted' | 'denied' | 'unset'

export const useUiStore = defineStore('ui', {
  state: () => ({
    mobileMenuOpen: false,
    consent: 'unset' as Consent,
  }),
  actions: {
    toggleMobileMenu(v?: boolean) {
      this.mobileMenuOpen = v ?? !this.mobileMenuOpen
    },
    loadConsent() {
      if (typeof localStorage === 'undefined') return
      const v = localStorage.getItem('adt-consent')
      this.consent = v === 'granted' ? 'granted' : v === 'denied' ? 'denied' : 'unset'
    },
    setConsent(v: Consent) {
      this.consent = v
      if (typeof localStorage !== 'undefined' && v !== 'unset') {
        localStorage.setItem('adt-consent', v)
      }
    },
  },
})
